import { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom-v5-compat";
import { useLocation } from "react-router-dom-v5-compat";
import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon, Logo } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./PageHeader.module.scss";
import { PATH_DISRUPTION_EXERCISE } from "@/utils/urlPaths";

export interface PageHeaderComponentProps extends PlatformComponentProps {
  title?: string;
  subtitle?: string;
  onBackClick?: () => void;
}
export const PageHeader = ({
  children,
  className,
  title,
  subtitle,
  onBackClick,
}: PageHeaderComponentProps) => {
  const COMPONENT_KEY = CoreUiComponents.PageHeader;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const hideTopHeader = useMemo(
    () => pathname === PATH_DISRUPTION_EXERCISE,
    [pathname]
  );

  return (
    !hideTopHeader && (
      <div className={clsx(block, className)}>
        <div className={cn("logo")}>
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <button
          onClick={() => (onBackClick ? onBackClick() : navigate(-1))}
          className={cn("back-button")}
        >
          <Icon iconName={IconNameEnum.backIcon} />
        </button>
        {title || subtitle ? (
          <div>
            <div className={cn("title")}>{title}</div>
            <div className={cn("sub-title")}>{subtitle}</div>
          </div>
        ) : null}
        {children}
      </div>
    )
  );
};
